import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RenderedService } from '../../rendered.service';
import { ItemsService } from '@scaffold/services/items.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { SchoolService } from '@services/school.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslationService } from '@services/translation.service';
@Component({
  selector: 'scaffold-template',
  templateUrl: './template.component.html',
  styleUrls: ['../../rendered.component.scss', './template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplateComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy {
  public destroy$: Subject<boolean> = new Subject<boolean>();
  text = '';
  initialText = '';
  school_config;
  private _day_array = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  style: string;

  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private itemsService: ItemsService,
    private schoolSettings: SchoolService,
    private translationService:TranslationService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.style = this.setStyles()
    this.text = this.item.template_text;
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((trigger) => {
        this.cdr.detectChanges();
      });
    this.item.template_keys_used = [];
    this.item.content.forEach((ite) => {
      this.item.template_keys_used.push(ite.name);
    });
    // get scool level setting to use for template drawing
    this.schoolSettings
      .getSettings()
      .pipe(takeUntil(this.destroy$))
      .subscribe((set) => {
        this.school_config = set;
        if (this.school_config.StartDay) {
          const index = this._day_array.indexOf(this.school_config.StartDay);
          if (index > 0) {
            const start = this._day_array.slice(index);
            const end = this._day_array.slice(0, index);
            this._day_array = start.concat(end);
          }
        }
        // Update the individual content items if their data has changed
        this.itemsService
          .registerItem(this.info)
          .pipe(takeUntil(this.destroy$))
          .subscribe((d) => {
            let needsUpdate = false;
            this.item.content.forEach((i) => {
              if (d.hasOwnProperty(i.name) && i.value !== d[i.name]) {
                i.value = d[i.name];
                needsUpdate = true;
              }
            });
            if (needsUpdate) {
              this.buildTemplateContent();
              this.redraw();
            }
          });
      //  this.initialText = this.generateTemplate();
        this.buildTemplateContent();
        this.redraw();
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    this.cdr.detach();
  }

  setStyles(){
    const {text_color,text_font_family,text_font_size,text_font_weight,text_style} = this.item
    let styles = ''
    if(text_color)styles+=`color:${text_color};`
    if(text_font_family)styles+=`font-family:${text_font_family};`
    if(text_font_size)styles+=`font-size:${text_font_size};`
    if(text_font_weight)styles+=`font-weight:${text_font_weight};`
    if(text_style)styles+=`font-style:${text_style};`
    return styles
  }

  getValue(data, key) {
    let prefix = '';
    if (this.paramprefix) {
      prefix = this.paramprefix + (this.paramprefix.length > 0 ? '.' : '');
    }
    return this.itemsService.get(
      data,
      prefix + (prefix.length > 0 ? '.' : '') + key
    );
  }

  // TODO - getValue
  buildTemplateContent() {
    let text = this.generateTemplate();
    if (this.text !== text) {
      this.text = text;
      if (this.item.store_in) {
        if (!/^\s*$/.test(this.text) && text !== this.initialText) {
          this.itemsService.updateValue(
            this.item.store_in,
            this.text,
            this.info
          );
        }
      }
    }
   this.redraw();
  }

  generateTemplate() {
    let text = '';
    this.item.content.forEach((ite) => {
      if(ite?.input_type==='percent'){
        const value = !isNaN(+ite.value)?ite.value :!isNaN(+ite.text)?ite.text:''
        if(value!==''){
          return text+= " "+(value * 100).toFixed(2) + "%" 
        }  
      }

      if (ite?.input_type === 'break') {
        text += '<br />';
      }
      else if (ite?.input_type === 'text') {
        let content = ite.text
        if(ite.translation_key){
          content =  this.translationService.getTranslatedContent(ite.translation_key,ite.text)
        }
        
        if(content&&ite.text_transform){
          content=this.translationService.transform(content,ite.text_transform)
        }
        text += content

      }
      else if (ite?.input_type === 'filesize' && ite.value) {
        const size = this.getFileSize(ite.value);
        text += `${size}`;
      } else if (ite?.input_type === 'day_array' && ite.value && ite.value.push) {
        if (ite.value.length === 1) {
          if (ite.use_numbers) {
            text += 'Day ' + Number(ite.value[0]) + 1;
          } else {
            text += this._day_array[ite.value[0]];
          }
        } else if (ite.value.length > 1) {
          if (ite.use_numbers) {
            text +=
              'Day ' +
              (Number(ite.value[0]) + 1) +
              ite.seperator +
              'Day ' +
              (Number(ite.value[ite.value.length - 1]) + 1);
          } else {
            text +=
              this._day_array[ite.value[0]] +
              ite.seperator +
              this._day_array[ite.value[ite.value.length - 1]];
          }
        }
      } else if (ite?.input_type === 'data') {
        ite.value = this.getCurrentValue(ite);
        text += ite.value !== undefined || ite.value !== null ? ite.value : '';
      } else {
        text += ite.text;
      }
    });
    return text;
  }

  getFileSize(value) {
    let size = Number(value);
    if (size > 1000 && size < 1000000) {
      size = size / 1000;
      return size.toFixed(2) + 'kb';
    } else if (size > 1000000) {
      size = size / 1000000;
      return size.toFixed(2) + 'mb';
    } else {
      return size + 'b';
 }
  }

  getCurrentValue(ite) {
    const updated = this.getValue(this.data, ite.name) || ite.value || ite.text;
    if (updated !== undefined && updated !== null) {
      return updated;
    } else {
      return '';
    }
  }
}
